import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { IntercomContext } from 'lib/contexts/intercom';

export const IntercomProvider = ({ appId, children }) => {
  useEffect(() => {
    window.intercomSettings = { app_id: appId, hide_default_launcher: true };
    const script = document.createElement('script');
    script.textContent = `
    (function () {
      var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', intercomSettings); } else {
        var d = document; var i = function () { i.c(arguments) }; i.q = []; i.c = function (args) { i.q.push(args) }; w.Intercom = i; function l() {
          var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true;
          s.src = 'https://widget.intercom.io/widget/${appId}';
          var x = d.getElementsByTagName('script')
          [0]; x.parentNode.insertBefore(s, x);
        } if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); }
      }
    })()`;
    document.head.appendChild(script);
    return () => document.head.removeChild(script);
  }, [appId]);

  return (
    <IntercomContext.Provider
      value={{
        appId,
        Intercom: global.Intercom,
      }}
    >
      {children}
    </IntercomContext.Provider>
  );
};

IntercomProvider.propTypes = {
  appId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
